/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {DirectiveOptions, VNode} from 'vue';
import InlineSvg from '@/directives/SvgRender/InlineSvg';
import {DirectiveBinding} from 'vue/types/options';

/**
 * Directive used to render an svg inline from a given HTMLImageElement src.
 */
export const SvgRender: DirectiveOptions = {
    /**
     * Directive binding function.
     * @param {HTMLElement} el
     * @param {DirectiveBinding} binding
     * @param {VNode} vnode
     */
    bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode): void {
        if (el instanceof HTMLImageElement) {
            InlineSvg.execute(el);
        }
    },
};
